import * as React from "react"
import { Action, IOWidget, mk_widget } from "widgets-for-react"
import { CMSState, Url } from "../../../../cms/blocks/types.gen"
import { link, linkWrapper } from "../../../../cms/blocks/utils.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { toRelativeUrl } from "../../../../../helpers";
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";

export type DownloadBlockProps = {
  index: number
  title?: string
  intro?: string
  primary_button?: ButtonData
  secondary_button?: ButtonData
  items: DownloadProps[]
  useSVGIcons: boolean
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type DownloadProps = {
  key?: string
  title: string
  text?: string
  file_url: Url
}

export function DownloadBlock<customBlockData, extra_images>(
  props: DownloadBlockProps,
  options?: { key?: string }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => (
        <section
          className="block block--download-list"
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <div className="block__inner container--xs grid--block">

            {(props.title || props.intro) && (
              <header className="block__header">
                {props.title && <h2 className="block__title typo--3xl">{props.title}</h2>}
                {props.intro && <p className="block__intro" dangerouslySetInnerHTML={{ __html: props.intro }}></p>}
              </header>
            )}

            <div className="block__content">
              <ul className="block__list list-iconed list-iconed--download">
                {props.items.map((link, index) => (
                  <li>
                    <a
                      download={true}
                      target="_blank"
                      href={link.file_url}
                      onClick={() => window.dataLayer.push({
                        event: "event.fccorporate", category: "Downloads", action: link.title, label: window.location.pathname
                      })}
                    > 
                     {link.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {(props.primary_button || props.secondary_button) && (
              <footer className="block__footer">
                {props.primary_button && (
                    link(linkWrapper({title:props.primary_button.text,url:props.primary_button.url}),
                      { classname: 'button button--primary' },
                      props.primary_button.text
                    )
                )}
                {props.secondary_button && (
                    link(linkWrapper({title:props.secondary_button.text,url:props.secondary_button.url}),
                      { classname: 'button button--secondary' },
                      props.secondary_button.text
                    )
                )}
              </footer>
            )}
          </div>
        </section>
      ),
    })
}
